<template>
  <div v-if="content">
    <div class="grid md:grid-cols-3 bg-white">
      <div class="col-span-1 py-6 px-8 md:pr-0 min-h-300">
        <div class="d-flex items-start gap-6">
          <img
            src="/img/leaf.png"
            class="w-12"
            loading="lazy"
            alt=""
            :class="[
              { 'filter-blue-700': content.theme === 'blue' },
              { 'filter-yellow-500': content.theme === 'yellow' },
              { 'filter-green-700': content.theme === 'green' },
              { 'filter-red-500': content.theme === 'red' },
              { 'filter-black': content.theme === 'black' }
            ]"
          />
          <h2 class="font-luckiest text-xl md:text-4xl text-blue-500">{{ content.title }}</h2>
        </div>
        <p class="text-blue-500 mt-6 font-medium leading-6">{{ content.text }}</p>
      </div>
      <div class="col-span-2 relative attraction-skew">
        <img
          v-if="content.img1"
          class="w-full h-52 md:h-full md:absolute inset-0 object-center object-cover"
          :src="content.img1 + '/m/700x0'"
          alt=""
        />
        <img
          v-else
          class="w-full h-full md:absolute inset-0 object-center object-cover"
          src="//a.storyblok.com/f/56057/500x900/d8d2e9cce2/placeholder_cav.jpg"
          alt=""
        />
      </div>
    </div>
    <div
      v-if="
        content.age_minimum ||
          content.height_minimum ||
          content.duration ||
          content.level ||
          content.shared
      "
      class="grid grid-cols-2 md:grid-cols-4 gap-4 p-6 place-items-center relative z-10"
      :class="[
        { 'bg-blue-700 text-white': content.theme === 'blue' },
        { 'bg-yellow-500 text-black': content.theme === 'yellow' },
        { 'bg-green-700 text-white': content.theme === 'green' },
        { 'bg-red-500 text-white': content.theme === 'red' },
        { 'bg-black text-white': content.theme === 'black' }
      ]"
    >
      <div v-if="content.age_minimum" class="d-flex items-center gap-4">
        <img
          class="w-12"
          :class="{ 'filter-black': content.theme === 'yellow' }"
          src="/img/family.png"
          alt=""
        />
        <p class="font-bold">dès {{ content.age_minimum }} ans</p>
      </div>
      <div v-if="content.height_minimum" class="d-flex items-center gap-4">
        <img
          class="w-12"
          :class="{ 'filter-black': content.theme === 'yellow' }"
          src="/img/taille.png"
          alt=""
        />
        <p class="font-bold">{{ formatCmInMeter }}</p>
      </div>
      <div v-if="content.duration" class="d-flex items-center gap-4">
        <img
          class="w-10"
          :class="{ 'filter-black': content.theme === 'yellow' }"
          src="/img/clock.png"
          alt=""
        />
        <p class="font-bold">{{ content.duration }} min</p>
      </div>
      <div v-if="content.level" class="d-flex items-center gap-4">
        <img
          class="w-10"
          :class="{ 'filter-black': content.theme === 'yellow' }"
          src="/img/climbing.png"
          alt=""
        />
        <p class="font-bold">{{ content.level }}</p>
      </div>
      <div v-if="content.shared" class="d-flex items-center gap-4">
        <img
          class="w-10"
          :class="{ 'filter-black': content.theme === 'yellow' }"
          src="/img/shared.png"
          alt=""
        />
        <p class="font-bold">Parcours<br />partagé</p>
      </div>
    </div>
    <!-- <div class="card-item" :style="`background-image:url('${this.img}')`" @click="this.showPopup" v-editable="content">
      <div class="card-info">
        <fai icon="angle-right" class="icon"></fai>
        <TextBloc class="text-content" :content="content" />
        <h3 v-html="content.title" :style="`background-color:${bgColor}`"></h3>
      </div>
      <div class="age" :style="`background-color:${bgColor}`">{{$t(`attractions.type.${content.type[0]}`)}}</div>
    </div>
    <div v-if="content.img2" @click="this.showPopup" class="popup" :style="`background-image:url(${content.img2})`" v-bind:class="{ active: popup }"></div> -->
  </div>
</template>

<script>
import imgOpti from "@/mixins/imgOpti.js";
export default {
  mixins: [imgOpti],
  props: {
    content: null
  },
  data() {
    return {
      // popup: false,
      // id: this.$route.params.id,
      // relWidth: null,
      // img: ""
    };
  },
  mounted() {
    // let e = document.getElementsByClassName("card-item");
    // this.relWidth = Math.trunc(e[0].offsetWidth * 1.5);
    // let img;
    // if (!this.content.img1) {
    //   img = "//a.storyblok.com/f/56057/500x900/d8d2e9cce2/placeholder_cav.jpg";
    // } else {
    //   img = this.content.img1;
    // }
    // this.img = this.optimize(img, this.relWidth);
  },
  methods: {
    // showPopup() {
    //   return (this.popup = !this.popup);
    // },
    // type(input) {
    //   if (input == "Au sol") {
    //     return "Jeux au sol";
    //   } else {
    //     return "Parcours dans les arbres";
    //   }
    // },
    // getStyle() {
    //   return this.content.img1
    //     ? `background-image:url('${this.optimize(this.content.img1, "700")}')`
    //     : `background-image : url('https://a.storyblok.com/f/56057/500x900/d8d2e9cce2/placeholder_cav.jpg')`;
    // }
  },
  computed: {
    // bgColor() {
    //   return this.id == "sainte-foy" ? "#e96e0f" : "#436c90";
    // },
    formatCmInMeter: function() {
      if (this.content.height_minimum.length === 3) {
        const formatMeter = this.content.height_minimum.split("");
        formatMeter.splice(1, 0, "m");
        return formatMeter.join("");
      }
      return this.content.height_minimum;
    }
  }
};
</script>

<style lang="scss">
.attraction-skew {
  @screen md {
    clip-path: polygon(12% 0, 100% 0, 100% 100%, 0% 100%);
  }
}
.min-h-300 {
  @screen md {
    min-height: 300px;
  }
}
// .card-item {
//   position: relative;
//   height: 100%;
//   width: 100%;
//   background-repeat: no-repeat;
//   background-position: center;
//   background-size: cover;
//   .age {
//     position: absolute;
//     top: 0;
//     color: white;
//     right: 0;
//     text-align: center;
//     width: 30%;
//     padding: 1em;
//     background-color: #4fbad1;
//   }
//   .card-info {
//     position: absolute;
//     left: 0;
//     width: 100%;
//     bottom: 0;
//     top: 0;
//     background-color: rgba(0, 0, 0, 0.3);
//     padding: 30px 20px;
//     display:none;
//     h3 {
//       line-height: 1.2;
//       color: #fff;
//       position: absolute;
//       bottom: 0;
//       left: 0;

//       width: 100%;
//       padding: 15px;
//     }
//     .icon {
//       color: white;
//       font-size: 65px;
//       margin-bottom: 5px;
//     }
//     .text-content {
//       color: white;
//       font-weight: 600;
//       line-height: 1.1;
//       text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
//     }
//   }
// }
// .popup {
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   width: 850px;
//   height: 0;
//   background-repeat: no-repeat;

//   background-position: inherit;
//   transition: all 0.8s ease;
//   &.active {
//     transition: all 0.8s ease-in-out;
//     width: 850px;
//     height: 1000px;
//   }
// }
// @media screen and (min-width: $desktop) {
//   #parc-page {
//     .card-item {
//       overflow: hidden;
//       position: relative;
//       .card-info {
//         background-color: rgba(0, 0, 0, 0.1);

//         display:block;
//         .textBloc {
//           transform: translateY(195px);
//           transition: transform 0.4s ease-in-out;
//         }
//         &:hover {
//           .textBloc {
//             transition: transform 0.2s ease-in-out;
//             transform: translateY(-20px);
//           }
//           background-color: rgba(0, 0, 0, 0.5);
//         }
//       }
//     }
//   }
// }
</style>
